import styled from "styled-components";

const SmallText = styled.span`
  font-size: 12px;
  color: #666666;
  margin-bottom: 8px;
`;

export default SmallText;
